type LocaleMap = { [key: string]: Map<number, string> };

export const LocaleWeekdayNames: LocaleMap = {
  kea: new Map<number, string>([
    [1, "sigunda-fera"],
    [2, "tersa-fera"],
    [3, "kuarta-fera"],
    [4, "kinta-fera"],
    [5, "sesta-fera"],
    [6, "sábadu"],
    [7, "dumingu"],
  ]),
  ht: new Map<number, string>([
    [1, "Lendi"],
    [2, "Madi"],
    [3, "Mèkredi"],
    [4, "Jedi"],
    [5, "Vandredi"],
    [6, "Samdi"],
    [7, "Dimanch"],
  ]),
  hy: new Map<number, string>([
    [1, "երկուշաբթի"],
    [2, "երեքշաբթի"],
    [3, "չորեքշաբթի"],
    [4, "հինգշաբթի"],
    [5, "ուրբաթ"],
    [6, "շաբաթ"],
    [7, "կիրակի"],
  ]),
  swc: new Map<number, string>([
    [1, "Siku ya 1"],
    [2, "Siku ya 2"],
    [3, "Siku ya 3"],
    [4, "Siku ya 4"],
    [5, "Siku ya 5"],
    [6, "Siku ya posho"],
    [7, "Siku ya yenga"],
  ]),
  "vec-BR": new Map<number, string>([
    [1, "Luni"],
    [2, "Marti"],
    [3, "Mèrcore"],
    [4, "Dóbia"],
    [5, "Vendre"],
    [6, "Sabo"],
    [7, "Doménega"],
  ]),
  pa: new Map<number, string>([
    [1, "ਸੋਮਵਾਰ"],
    [2, "ਮੰਗਲਵਾਰ"],
    [3, "ਬੁੱਧਵਾਰ"],
    [4, "ਵੀਰਵਾਰ"],
    [5, "ਸ਼ੁੱਕਰਵਾਰ"],
    [6, "ਸ਼ਨੀਵਾਰ"],
    [7, "ਐਤਵਾਰ"],
  ]),
};

export const LocaleMonthNames: LocaleMap = {
  kea: new Map<number, string>([
    [0, "Janeru"],
    [1, "Febreru"],
    [2, "Marsu"],
    [3, "Abril"],
    [4, "Maiu"],
    [5, "Junhu"],
    [6, "Julhu"],
    [7, "Agostu"],
    [8, "Setenbru"],
    [9, "Otubru"],
    [10, "Nuvenbru"],
    [11, "Dizenbru"],
  ]),
  ht: new Map<number, string>([
    [0, "Janvye"],
    [1, "Fevriye"],
    [2, "Mas"],
    [3, "Avril"],
    [4, "Me"],
    [5, "Jen"],
    [6, "Jiyè"],
    [7, "Out"],
    [8, "Septanm"],
    [9, "Oktòb"],
    [10, "Novanm"],
    [11, "Desanm"],
  ]),
  hy: new Map<number, string>([
    [0, "հունվարի"],
    [1, "փետրվարի"],
    [2, "մարտի"],
    [3, "ապրիլի"],
    [4, "մայիսի"],
    [5, "հունիսի"],
    [6, "հուլիսի"],
    [7, "օգոստոսի"],
    [8, "սեպտեմբերի"],
    [9, "հոկտեմբերի"],
    [10, "նոյեմբերի"],
    [11, "դեկտեմբերի"],
  ]),
  swc: new Map<number, string>([
    [0, "Mwezi wa 1"],
    [1, "Mwezi wa 2"],
    [2, "Mwezi wa 3"],
    [3, "Mwezi wa 4"],
    [4, "Mwezi wa 5"],
    [5, "Mwezi wa 6"],
    [6, "Mwezi wa 7"],
    [7, "Mwezi wa 8"],
    [8, "Mwezi wa 9"],
    [9, "Mwezi wa 10"],
    [10, "Mwezi wa 11"],
    [11, "Mwezi wa 12"],
  ]),
  "vec-BR": new Map<number, string>([
    [0, "Genaro"],
    [1, "Febraro"],
    [2, "Marso"],
    [3, "April"],
    [4, "Maio"],
    [5, "Giugno"],
    [6, "Lùlio"],
    [7, "Agosto"],
    [8, "Setembre"],
    [9, "Otobre"],
    [10, "Novembre"],
    [11, "Disembre"],
  ]),
  pa: new Map<number, string>([
    [0, "ਜਨਵਰੀ"],
    [1, "ਫ਼ਰਵਰੀ"],
    [2, "ਮਾਰਚ"],
    [3, "ਅਪ੍ਰੈਲ"],
    [4, "ਮਈ"],
    [5, "ਜੂਨ"],
    [6, "ਜੁਲਾਈ"],
    [7, "ਅਗਸਤ"],
    [8, "ਸਤੰਬਰ"],
    [9, "ਅਕਤੂਬਰ"],
    [10, "ਨਵੰਬਰ"],
    [11, "ਦਸੰਬਰ"],
  ]),
};

export const LocaleMonthNamesShort: LocaleMap = {
  hy: new Map<number, string>([
    [0, "Հնվ"],
    [1, "Փտվ"],
    [2, "Մրտ"],
    [3, "Ապր"],
    [4, "Մյս"],
    [5, "Հնս"],
    [6, "Հլս"],
    [7, "Օգս"],
    [8, "Սեպ"],
    [9, "Հոկ"],
    [10, "Նոյ"],
    [11, "Դեկ"],
  ]),
};
